module.exports = __webpack_public_path__ + "static/media/customize-bol.ce9ea420.png";